document.addEventListener("DOMContentLoaded", function () {
  var productCards = document.querySelectorAll('.quick-add-card');

  productCards.forEach(function (card) {
    let selectedVariantId = null;

    var variantButtons = card.querySelectorAll('.variant-btn');

    variantButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (this.disabled) {
          return;
        }

        variantButtons.forEach(function (btn) {
          btn.classList.remove('selected');
        });

        this.classList.add('selected');
        selectedVariantId = this.getAttribute('data-variant-id');

        var addToCartButton = card.querySelector('.quick-add-btn');
        addToCartButton.disabled = false;
        addToCartButton.setAttribute('data-variant-id', selectedVariantId);
      });
    });

    var addToCartButton = card.querySelector('.quick-add-btn');

    // Enable "Add to Cart" if no variants (for single-variant products)
    if (!addToCartButton.hasAttribute('disabled') && !addToCartButton.getAttribute('data-variant-id')) {
      var firstVariantId = card.querySelector('.single-variant-id') ? card.querySelector('.single-variant-id').value : null;
      if (firstVariantId) {
        addToCartButton.setAttribute('data-variant-id', firstVariantId);
      }
    }

    // Handle Add to Cart button click
    addToCartButton.addEventListener('click', function () {
      var variantId = this.getAttribute('data-variant-id');

      if (!variantId) {
        alert("Please select a variant first.");
        return;
      }

      card.querySelector('.quick-add-loader').style.display = 'block';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: 1
          }]
        })
      })
      .then(response => response.json())
      .then(data => {
        card.querySelector('.quick-add-loader').style.display = 'none';
        var successMessage = card.querySelector('.quick-add-success');
        successMessage.style.display = 'block';

        setTimeout(function() {
          successMessage.style.display = 'none';
        }, 2000);

        return fetch('/cart.js');
      })
      .then(response => response.json())
      .then(cartData => {
        var cartCountElement = document.querySelector('.cart-count');
        cartCountElement.innerText = cartData.item_count;

        selectedVariantId = null;
      })
      .catch(error => console.error('Error adding product to cart:', error));
    });
  });
});
